
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m8.5702 12.057c0.72287 1.4779 1.9208 2.6704 3.4019 3.3865 0.1084 0.0513 0.2283 0.0736 0.3478 0.0645 0.1196-9e-3 0.2348-0.049 0.3342-0.1161l2.1808-1.4543c0.0965-0.0643 0.2075-0.1035 0.3229-0.1141s0.2317 0.0077 0.3383 0.0534l4.0799 1.7486c0.1386 0.0588 0.2543 0.1612 0.3297 0.2915 0.0754 0.1304 0.1064 0.2817 0.0883 0.4312-0.129 1.0091-0.6213 1.9365-1.3849 2.6088-0.7635 0.6722-1.7459 1.043-2.7632 1.0431-3.142 0-6.1553-1.2482-8.377-3.4699s-3.4699-5.235-3.4699-8.377c6e-5 -1.0173 0.37091-1.9997 1.0431-2.7632 0.67222-0.76355 1.5997-1.2559 2.6088-1.3848 0.14949-0.01809 0.30081 0.01289 0.43117 0.08828 0.13035 0.07539 0.23267 0.19109 0.29155 0.32969l1.7501 4.0835c0.0453 0.10562 0.0637 0.2208 0.0537 0.33528s-0.0482 0.2247-0.1111 0.32085l-1.4492 2.2143c-0.06596 0.0996-0.10495 0.2146-0.11317 0.3338-0.00821 0.1192 0.01463 0.2385 0.06629 0.3462v0z","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('path',{attrs:{"d":"m14 9.9999 6-6m0 0h-5m5 0v5","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])
          )
        }
      }
    